import { useEffect, type VoidFunctionComponent } from 'react';

import { useDebouncedInputValue } from '../../hooks';
import { SearchInput } from '../generic';

export type Props = {
  /**
   * The initial search value.
   */
  initialSearch: string;
  /**
   * Callback function to handle debounced changes to the search input.
   */
  onSearchChange: (value: string) => void;
};

/**
 * SearchBar component for filtering tools by name. It uses a debounced input
 * value to avoid excessive updates.
 */
const SearchBar: VoidFunctionComponent<Props> = ({ initialSearch, onSearchChange }) => {
  const { value, onChange, debouncedValue } = useDebouncedInputValue(initialSearch);

  useEffect(() => {
    onSearchChange(debouncedValue);
  // We only want to call this when the debounced value changes.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue]);

  return (
    <SearchInput
      value={value}
      onChange={onChange}
      size="small"
      label="tools-filter-name"
      testId="tools-filter-name"
    />
  );
};

export default SearchBar;
